export default __webpack_public_path__ + "static/media/logo.4271b899.svg";